<script setup lang="ts">
// @ts-ignore
import { Container } from 'vue3-smooth-dnd';
import type { ContainerElement, FormElement } from '../types';
import type { SmoothDnDDropProps } from 'vince-ui/types/common';
import { type FormElementConfig, FormElementsConfigMap } from 'vince-core/pages/form-builder/constants';
import { useFormEditStore } from 'vince-core/pages/form-builder/formEditStore';

const { t } = useI18n();

const props = defineProps<{
    element: ContainerElement
    root?: boolean
}>();

const store = useFormEditStore();


const handleDrop = ({ addedIndex, removedIndex, payload }: SmoothDnDDropProps<FormElementConfig | FormElement>) => {
    if ((removedIndex === null && addedIndex === null) || (removedIndex === addedIndex)) {
        return;
    }

    const el = Reflect.has(payload, 'create')
        ? (payload as FormElementConfig).create(props.element, t)
        : payload as FormElement;

    if (removedIndex !== null) {
        store.deleteElement(payload.id);
    }

    if (addedIndex !== null) {
        store.addElement(props.element, addedIndex!, el);
    }

    if (Reflect.has(payload, 'create')) {
        store.startElementEdit(el);
    }
};

const childPayload = (index: number) => {
    return props.element.children[index];
};

const elementsMap = computed(() => {
    return FormElementsConfigMap;
});

</script>
<template>
    <container
        v-if="element.direction ==='horizontal'"
        behaviour="move"
        drag-class="card-ghost"
        orientation="horizontal"
        :should-accept-drop="() => true"
        drop-class="card-ghost-drop"
        :get-child-payload="(index: number) => childPayload(index)"
        :drop-placeholder="{ className: 'drop-placeholder' }"
        @drop="handleDrop"
    >
        <component
            :is="elementsMap[el.type]!.builderComponent"
            v-for="el in element.children"
            :key="el.id"
            :element="el"
        />
    </container>
    <!-- had to copy because orientation is not dynamic prop :( -->
    <container
        v-else
        behaviour="move"
        drag-class="card-ghost"
        :should-accept-drop="() => true"
        drop-class="card-ghost-drop"
        :get-child-payload="(index: number) => childPayload(index)"
        :drop-placeholder="{ className: 'drop-placeholder' }"
        @drop="handleDrop"
    >
        <component
            :is="elementsMap[el.type]!.builderComponent"
            v-for="el in element.children"
            :key="el.id"
            :element="el"
        />
    </container>
</template>

<style scoped>
</style>

